import React from "react";
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, ZapIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
const badges = [{
  icon: DownloadIcon,
  text: "Descarga inmediata"
}, {
  icon: ZapIcon,
  text: "Pago único"
}, {
  icon: InfinityIcon,
  text: "Acceso de por vida"
}, {
  icon: ShieldCheckIcon,
  text: "Garantía de 7 días"
}];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-neutral-950 py-16" data-id="element-65" data-mp="1eek1rqvmpmgh">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[380px] opacity-40" style={{
      background: "radial-gradient(60% 100% at 50% 100%, rgba(245,184,0,0.18) 0%, rgba(11,11,11,0) 70%)"
    }} data-id="element-66" data-mp="1t2yd6q742j8n" />
      <div className="relative mx-auto max-w-lg px-4 text-center" data-id="element-67" data-mp="2245z08sfxrlu">
        <h2 className="font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-68" data-mp="1x5b6gf4o8ooj">
          🚀 Hoy puedes seguir improvisando…
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/70" data-id="element-69" data-mp="n7p2x52vyvfk">
          …o instalar el mismo sistema que ya está ayudando a miles de técnicos a
          trabajar con más orden, transmitir mayor confianza y dedicar menos
          tiempo al papeleo.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-70" data-mp="123n0mrsgk7tw">
          Cada día que postergas organizar tu negocio es un día más cobrando sin
          procesos, perdiendo tiempo y dejando oportunidades sobre la mesa.
        </p>
        <p className="mt-4 font-display text-base font-bold text-white" data-id="element-71" data-mp="1b172a1u8g651">
          Haz clic en el botón de abajo y comienza hoy mismo.
        </p>

        <div className="mt-8" data-id="element-72" data-mp="1ksbggzc33myt">
          <CtaButton label="Quiero el Sistema Técnico PRO 360™" data-id="element-73" data-mp="1ksl4ihdkjk1v" />
        </div>

        <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.03] p-4" data-id="element-74" data-mp="1ptr3uy1qi5kd">
          <CountdownTimer data-id="element-75" data-mp="1tv2t32gp4os1" />
        </div>

        <ScarcityBar className="mt-4" data-id="element-76" data-mp="1tryedb5luan4" />

        <ul className="mt-6 grid grid-cols-2 gap-2.5" data-id="element-77" data-mp="3qtvxuemhj6gr">
          {badges.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.03] px-2 py-2.5 text-xs font-semibold text-white/80" data-id="element-78" data-mp="3lwndc7dv6qcc">
              <Icon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-79" data-mp="3uupm593uana6" />
              {text}
            </li>)}
        </ul>

        <footer className="mt-12 border-t border-white/10 pt-6" data-id="element-80" data-mp="dhltl6ov9in5">
          <p className="font-display text-sm font-bold text-amber-400" data-id="element-81" data-mp="8fwixs5k36zl">
            🔧 Sistema Técnico PRO 360™
          </p>
          <p className="mt-2 text-xs text-white/40" data-id="element-82" data-mp="mecvw0u0htq6">
            © {new Date().getFullYear()} Sistema Técnico PRO 360. Todos los
            derechos reservados.
          </p>
        </footer>
      </div>
    </section>;
}